/**
 * If browsers are missing some Javascript function add polyfills to this file.
 */

// Element.matches polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/Element/matches
// IE11/Edge/Legacy webkit
if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
}

// Element.closest polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
// IE11
if (!Element.prototype.closest) {
  Element.prototype.closest = function(s) {
    var el = this;

    do {
      if (Element.prototype.matches.call(el, s)) return el;
      el = el.parentElement || el.parentNode;
    } while (el !== null && el.nodeType === 1);
    return null;
  };
}

// NodeList.forEach polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/NodeList/forEach
// IE11
if ('NodeList' in window && !NodeList.prototype.forEach) {
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

// CustomEvent constructor polyfill
// https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent
// IE11
if (typeof window.CustomEvent !== 'function') {
  window.CustomEvent = function(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent('CustomEvent');
    evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
    return evt;
  };
}
